import http from "./http";
const baseUrl = "/v1/api/app";

const { get, post } = http;
const getDevicePluginPage = (params: any) => post(`${baseUrl}/so/page`, params); // 列表
const getDevicePluginNoPage = (params: any) => post(`${baseUrl}/so/list`, params); // 获取设备插件不分页
const createDevicePlugin = (params: any) => post(`${baseUrl}/so/create`, params); // 创建
const deleteDevicePlugin = (params: any) => post(`${baseUrl}/so/delete`, params); // 删除

const getDevicePluginDetail = (params: any) => post(`${baseUrl}/so/detail`, params); // 详情
const saveDevicePlugin = (params: any) => post(`${baseUrl}/so/save`, params); // 保存
const existDevicePluginPackageName = (params: any) => post(`${baseUrl}/so/packageName/exist`, params); // 包名校验
const existDevicePluginVersion = (params: any) => post(`${baseUrl}/so/version/exist`, params); // 版本号校验
const saveNextDevicePlugin = (params: any) => post(`${baseUrl}/so/next/save`, params); // 保存并下一步
const auditReleaseDevicePlugin = (params: any) => post(`${baseUrl}/so/audit/release`, params); // 审核上架
const auditUpgradeDevicePlugin = (params: any) => post(`${baseUrl}/so/audit/upgrade`, params); // 审核升级
const cancelReleaseDevicePlugin = (params: any) => post(`${baseUrl}/so/cancel/release`, params); // 撤销上架
const cancelUpgradeDevicePlugin = (params: any) => post(`${baseUrl}/so/cancel/upgrade`, params); // 撤销升级
const cancelDownDevicePlugin = (params: any) => post(`${baseUrl}/so/cancel/down`, params); // 撤销下架
const upgradeVersionDevicePlugin = (params: any) => post(`${baseUrl}/so/version/upgrade`, params); // 升级版本
const auditDownDevicePlugin = (params: any) => post(`${baseUrl}/so/audit/down`, params); // 审核下架
export default {
    getDevicePluginPage,
    getDevicePluginNoPage,
    createDevicePlugin,
    deleteDevicePlugin,
    getDevicePluginDetail,
    saveDevicePlugin,
    existDevicePluginPackageName,
    existDevicePluginVersion,
    saveNextDevicePlugin,
    auditReleaseDevicePlugin,
    auditUpgradeDevicePlugin,
    cancelReleaseDevicePlugin,
    cancelUpgradeDevicePlugin,
    cancelDownDevicePlugin,
    upgradeVersionDevicePlugin,
    auditDownDevicePlugin
}